import { getMergeValue, merge } from '../../helper';

import addClass from '../../general/class/addClass';

import * as exElement from '../element';

import type { IIconConfig } from './types';

// ----------------------------------------------------------------------------

export type TypeBuildReturn = {
    element: HTMLElement;
    elements: {
        element: HTMLElement;
    };
};

// ----------------------------------------------------------------------------

function create(config: IIconConfig | string = {}): HTMLElement {
    // Default Config
    const defConfig: IIconConfig = {
        type: getMergeValue(config),
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build = {
        elements: {},
    } as TypeBuildReturn;

    // ------------------------------------------------------------------------

    // Create element (icon)
    const elIcon = exElement.create({
        merge: defConfig,
        tag: 'i',
    });
    build.elements.element = elIcon;
    build.element = elIcon;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build.element;
}

function settings(build: TypeBuildReturn, config: IIconConfig = {}): void {
    const element = build.element;

    // If using type
    if (config.type != null && typeof config.type === 'string') {
        addClass(element, config.type);
    }

    // ------------------------------------------------------------------------

    // If using function action
    if (typeof config.fnAction === 'function') {
        addClass(element, 'cursor-pointer');

        // Create event (click)
        element.addEventListener('click', function (this: HTMLElement, evt: Event): any {
            config.fnAction?.call(this, evt);
        });
    }
}

// ----------------------------------------------------------------------------

export default create;
